import React from "react";

const BattleshipIcon = () => {
    return (
        <svg
            width="6.25rem"
            height="3.75rem"
            viewBox="0 0 100 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.469 45.798L4 41.28L18.131 41.296L18.125 39.515H30.151L30.141 37.062H42.151L42.11 34.437H43.448V31.375H49.11L49.799 18.974H47.36L47.372 18.331H49.798L49.923 14H50.319L50.402 18.274H52.673L52.694 18.974H50.452L51.11 31.374H54.563L54.522 26.592C53.946 26.323 53.547 25.739 53.547 25.062C53.547 24.13 54.303 23.374 55.235 23.374H56.381C57.313 23.374 58.069 24.129 58.069 25.062C58.069 25.716 57.696 26.284 57.151 26.563L57.172 31.187H59.976V35.375H69.047V36.343L93.276 36.355L96.096 36.188L88.859 45.799"
                fill="white"
            />
            <path
                d="M8.46875 40.5H14.9377V36C14.9377 36 8.56275 35.813 8.46875 40.5Z"
                fill="white"
            />
            <path
                d="M28.49 38.708H22.021V34.208C22.022 34.208 28.397 34.021 28.49 38.708Z"
                fill="white"
            />
            <path
                d="M80.8811 35.812H74.4121V31.312C74.4121 31.312 80.7871 31.125 80.8811 35.812Z"
                fill="white"
            />
            <path
                d="M9.74523 36.791L5.85023 35.374L5.61523 36.02L9.10123 37.289C9.10023 37.289 9.40423 36.987 9.74523 36.791Z"
                fill="white"
            />
            <path
                d="M27.0132 34.957L30.9092 33.539L31.1442 34.185L27.6582 35.454C27.6582 35.454 27.3542 35.152 27.0132 34.957Z"
                fill="white"
            />
            <path
                d="M79.3462 32.022L83.2422 30.604L83.4772 31.25L79.9912 32.519C79.9912 32.52 79.6872 32.218 79.3462 32.022Z"
                fill="white"
            />
        </svg>
    );
};

export default BattleshipIcon;
